<!--
This file is part of the project: "Digiziege"
An app for animal-welfare-oriented goat husbandry and contactless weight estimation.
GitLab: https://gitlab.rlp.net/proj-wise2526-digiziege/digiziege

Copyright (c) 2026 Digiziege Team TH-Bingen

Description:
Companion app for welfare-oriented goat husbandry featuring contactless weight estimation via camera,
master data management and health tracking.
Built as a PWA with a local-first approach to ensure data privacy.

LICENSE INFORMATION:
This program is free software: you can redistribute it and/or modify it under the terms of the
GNU Affero General Public License as published by the Free Software Foundation,
either version 3 of the License, or (at your option) any later version.

This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
See the GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License along with this program.
If not, see <https://www.gnu.org/licenses/>.
-->

<template>
  <MoreItemWrapper
    :icon="TagIcon"
    :title="$t('views.more.eartagPrefix.title')"
    to="/more/eartag-prefix">
    <template #extra>
      <div
        class="text-sm font-medium px-3 py-1 rounded-full bg-[var(--color-primary-300)]"
        :class="hasPrefix ? 'font-mono' : 'italic opacity-70'">
        {{ displayValue }}
      </div>
    </template>
  </MoreItemWrapper>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { Tag as TagIcon } from 'lucide-vue-next'
import { useUiStore } from '@/stores/ui.store.js'
import MoreItemWrapper from './MoreItem.vue'

const { t } = useI18n()
const uiStore = useUiStore()

// Display current prefix
const hasPrefix = computed(() => uiStore.hasEartagPrefix())
const displayValue = computed(() => {
  const prefix = uiStore.getEartagPrefix()
  return prefix || t('views.more.eartagPrefix.notSet')
})
</script>
